import FieldsInput from "../../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../AddClient.style";
import { Stack } from "@fluentui/react";
import { EMAIL_VALIDATION_PATTERN } from "../../../../../utils/constants";
import { useTranslation } from "react-i18next";

const ContactEmail = (props) => {
  const { contactEmail, checkAccountData } = props;
  const { t } = useTranslation();
  const style = Style();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t("email_address")}
          validationMessage={props.errors?.contactEmail?.message}
          inputType="email"
          id="contactEmail"
          placeholder={t("enter_email_address")}
          name="contactEmail"
          inputDefaultValue={contactEmail}
          inputClassName={mergeClasses(style.textboxInput)}
          disabled={checkAccountData}
          validation={
            !checkAccountData
              ? props.register("contactEmail", {
                  required: `${t(
                    "validation_message.email_address_is_required"
                  )}`,
                  pattern: {
                    value: EMAIL_VALIDATION_PATTERN,
                    message: `${t(
                      "validation_message.email_not_match_format"
                    )}`,
                  },
                })
              : ""
          }
        />
      </Stack>
    </>
  );
};

export default ContactEmail;
